import { axios, useElementContext } from '@ten24/slatwall-storefront-react-private/global'
import { SlatwalApiService } from '@ten24/slatwall-storefront-react-private/global'
import { ProductSlider } from '../ProductSlider/ProductSlider'
import queryString from 'query-string';
import { useEffect } from 'react';
import { useState } from 'react';
import { ContentCard } from '../CMS/ContentCard/ContentCard';
import { Link } from 'react-router-dom';

const DynamicProductListing = props => {
  const { viewMode = 'celSlider', contentElementName, searchString } = props
  const cardDisplayConfigurations = {
    skuCardConfiguration: JSON.parse(props?.skuCardConfiguration || '{}'),
    productCardConfiguration: JSON.parse(props?.productCardConfiguration || '{}'),
  }
  let source = axios.CancelToken.source()
  let payload = queryString.parse(searchString)
  const [products, setProducts] = useState([])
  const { SkuCard } = useElementContext()

  useEffect(() => {
    SlatwalApiService.products.search(payload, {}, source).then(response => {
      // if (response.isSuccess() && Object.keys(response.success()?.errors || {}).length) setError({ isError: true, message: getErrorMessage(response.success().errors) })
      if (response.isSuccess()) {
        const data = response.success().data
        if (!!data.products && Array.isArray(data.products)) {
          const products = data.products.map(sku => {
            return { ...sku, salePrice: sku.skuPrice, productName: sku.product_productName, urlTitle: sku.product_urlTitle, productCode: sku.product_productCode, imageFile: sku.sku_imageFile, skuID: sku.sku_skuID, skuCode: sku.sku_skuCode }
          })

          setProducts(products)
        }
      }
    })
    //eslint-disable-next-line
  }, [])

  if (viewMode === '2c938084833c662e01833d163c01004c' || viewMode === 'celSlider') {
    return <ProductSlider products={products} title={contentElementName} cardConfiguration={cardDisplayConfigurations.skuCardConfiguration} />
  } else if (viewMode === 'celStack') {
    if (!products?.length) {
      return null
    }


    return (
      <div className='w-100'>
        <h3 className='fw-bold'>{contentElementName}</h3>
        <ContentCard contentCardLayout="card-overlay-left" contentBody={products[0].product_productDescription} contentHeading={products[0].productName} contentCardImage={products[0].defaultSku_imageFile ? products[0].defaultSku_imageFile : products[0].sku_imageFile} />
        <div className='d-flex mt-4 flex-wrap justify-content-between'>
          {
            products.map((product, idx) => {
              if (idx === 0) {
                return null
              }

              if (idx < 4) {
                return <SkuCard {...product} cardType="Third width Description Card" cardConfiguration={cardDisplayConfigurations.skuCardConfiguration} imageFile={product.defaultSku_imageFile ? product.defaultSku_imageFile : product.sku_imageFile} skuID={product.defaultSku_skuID} salePrice={product.salePrice} listPrice={product.listPrice} key={product.defaultSku_skuID} />
              }

              return null
            })
          }
        </div>
        <div className='w-100 text-center p-3'>
          <Link to="/shop">
            <b>Show More</b>
          </Link>
        </div>
      </div>
    )
  } else if (viewMode === 'celTiles') {
    if (!products?.length) {
      return null
    }
    return (
      <div className='w-100'>
        <h3 className='fw-bold'>{contentElementName}</h3>
        <div className='row'>
          {
            products.map((product, idx) => {
              if (idx < 6) {
                return <SkuCard {...product} cardType="Third width Description Card" cardConfiguration={cardDisplayConfigurations.skuCardConfiguration} imageFile={product.defaultSku_imageFile ? product.defaultSku_imageFile : product.sku_imageFile} skuID={product.defaultSku_skuID} salePrice={product.salePrice} listPrice={product.listPrice} key={product.defaultSku_skuID} />
              }

              return null
            })
          }
        </div>
        <div className='w-100 text-center p-3'>
          <Link to="/shop">
            <b>Show More</b>
          </Link>
        </div>
      </div>
    )
  }
  return null
}
export { DynamicProductListing }
